import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const UploadedImageRow: FC<Props> = ({ image, imageIndex, setImages }) => {
  const settingsApplied = getWatermarkTag(image) !== 'none';

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages as any}
          onClose={() => {}}
        />
      }
      showText={false}
      showPreview={false}
      imgRatioX={62}
      imgRatioY={63}
      freeFormCrop={true}
    />
  );
};

export default memo(UploadedImageRow);
